export function store(url, type, token, data){
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;

    return new Promise((resolve, reject)=>{
        fetch(baseUrl,{
            'method':type,
            'headers':{
                'Content-Type':'multipart/form-data',
                Accept:'application/json',
                Authorization:'Bearer '+token
            },
            body:JSON.stringify(data),
        }).then((response)=>response.json())
        .then((responseJson)=>{
            resolve(responseJson);
        })
        .then((error)=>{
            reject(error);
        })
    })

}


// WEBPACK FOOTER //
// ./src/Services/Destination.js